var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: "2rem",
    height: "2rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,6v2.414l-8,8v7.689l-6-3.866v-3.823L1,8.414v-2.414c0-1.654,1.346-3,3-3h2v2h-2c-.552,0-1,.448-1,1v1.586L11,15.586v3.562l2,1.288v-4.85L21,7.586v-1.586c0-.552-.448-1-1-1h-2V3h2c1.654,0,3,1.346,3,3Zm-10,3h-2c-.552,0-1-.448-1-1h-2c0,1.654,1.346,3,3,3v1h2v-1c1.654,0,3-1.346,3-3,0-1.359-.974-2.51-2.315-2.733l-3.04-.506c-.374-.062-.645-.382-.645-.761,0-.552,.448-1,1-1h2c.552,0,1,.448,1,1h2c0-1.654-1.346-3-3-3V0h-2V1c-1.654,0-3,1.346-3,3,0,1.359,.974,2.51,2.315,2.733l3.04,.506c.374,.062,.645,.382,.645,.761,0,.552-.448,1-1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryIcon);
export default __webpack_public_path__ + "static/media/salary-icon.d9680f253127f1243471ff5485f730d4.svg";
export { ForwardRef as ReactComponent };